import { Container, Heading } from 'pages/Error404/components';
import { Link } from 'react-router-dom';
import SkipNavLocation from 'components/common/SkipNavLocation';

export default function Error404(): JSX.Element {
  return (
    <Container>
      <SkipNavLocation>
        <Heading>
          <span>{"We can't find the page"}</span>
          <br />
          <span>{"you're looking for"}</span>
        </Heading>
        <Link to='/'>Go to homepage</Link>
      </SkipNavLocation>
    </Container>
  );
}
